<template>
  <div class="form-container">
    <transition name="slide" mode="out-in">
      <!-- 步骤1 -->
      <div v-if="currentStep === 1" key="step1">
        <div class="container" style="margin-top: 30px;">
          <div class="header">
            <div class="title">公司全称</div>
          </div>
          <el-form :model="formData" ref="formRef" label-width="0px">
            <div class="input-container">
              <el-form-item prop="companyName">
                <div class="autocomplete-wrapper">
                  <input 
                    type="text" 
                    class="input-field" 
                    v-model="formData.companyName"
                    @input="handleCompanyInput"
                    @focus="handleInputFocus"
                    @blur="handleInputBlur"
                    @keydown="handleKeydown"
                    placeholder="请输入您所属公司营业执照上的公司全称" 
                  />
                <span class="placeholder">请输入您所属公司营业执照上的公司全称</span>
                  
                  <!-- 下拉建议列表 -->
                  <div v-if="showSuggestions && companySuggestions.length > 0" class="suggestions-dropdown">
                    <div 
                      v-for="(company, index) in companySuggestions" 
                      :key="index"
                      class="suggestion-item"
                      :class="{ 'active': selectedIndex === index }"
                      @mousedown="selectCompany(company)"
                    >
                      <span v-html="highlightMatch(company.company_name, formData.companyName)"></span>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <!-- 第二个输入框 -->
        <div class="container" style="margin-top: 20px;">
          <div class="header">
            <div class="title">你的职位</div>
          </div>
          <el-form :model="formData" ref="formRef2" label-width="0px">
            <div class="input-container">
              <el-form-item prop="userPosition">
                <div class="autocomplete-wrapper">
                  <input 
                    type="text" 
                    class="input-field" 
                    v-model="formData.userPosition"
                    @input="handlePositionInput"
                    @focus="handlePositionFocus"
                    @blur="handlePositionBlur"
                    @keydown="handlePositionKeydown"
                    placeholder="请输入你的职位" 
                  />
                  <span class="placeholder">请输入你的职位</span>
                  
                  <!-- 下拉建议列表 -->
                  <div v-if="showPositionSuggestions && positionSuggestions.length > 0" class="suggestions-dropdown">
                    <div 
                      v-for="(position, index) in positionSuggestions" 
                      :key="index"
                      class="suggestion-item"
                      :class="{ 'active': selectedPositionIndex === index }"
                      @mousedown="selectPosition(position)"
                    >
                      <span v-html="highlightMatch(position.name, formData.userPosition)"></span>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="flex-row footer">
          <button class="submitButton" @click="handleNextStep">下一步</button>
          <button class="cancelButton" @click="handleBackStep">取消</button>
        </div>
      </div>

      <!-- 步骤2 -->
      <div v-if="currentStep === 2" key="step2">
        <!-- 您的姓名 -->
        <div class="container" style="margin-top: 20px;">
          <div class="header">
            <div class="title">您的姓名</div>
            </div>
          <el-form :model="formData" ref="formRef3" label-width="0px">
            <div class="input-container">
              <el-form-item prop="userName">
                <input type="text" class="input-field" v-model="formData.userName"
                  placeholder="请输入您的姓名" />
                <span class="placeholder">请输入您的姓名</span>
              </el-form-item>
              </div>
          </el-form>
            </div>

        <!-- 身份证号 -->
        <div class="container" style="margin-top: 20px;">
          <div class="header">
            <div class="title">身份证号</div>
          </div>
          <el-form :model="formData" ref="formRef4" label-width="0px">
            <div class="input-container">
              <el-form-item prop="userIdNo">
                <input type="text" class="input-field" v-model="formData.userIdNo"
                  placeholder="请输入您的身份证号" />
                <span class="placeholder">请输入您的身份证号</span>
            </el-form-item>
            </div>
          </el-form>
        </div>

        <!-- 手机号 -->
        <div class="container" style="margin-top: 20px; margin-bottom: 40px;">
          <div class="header">
            <div class="title">手机号</div>
          </div>
          <el-form :model="formData" ref="formRef5" label-width="0px">
            <div class="input-container">
              <el-form-item prop="userPhone">
                <input type="text" class="input-field" v-model="formData.userPhone"
                  placeholder="请输入您的手机号" />
                <span class="placeholder">请输入您的手机号</span>
              </el-form-item>
        </div>
          </el-form>
        </div>

        <div class="flex-row footer" style="position: relative; margin-top: 20px;">
          <button class="submitButton" @click="handleNextStep">下一步</button>
          <button class="cancelButton" @click="handleBackStep">取消</button>
        </div>
      </div>

      <!-- 步骤3 -->
      <div v-if="currentStep === 3" key="step3">
        <div class="upload-options">
          <!-- 营业执照上传 -->
          <div class="option" @click="handleLicenseUpload">
            <div class="option-icon"><img src="./assets/img/upload.png" alt=""></div>
            <div class="option-content">
              <div class="option-title">营业执照</div>
              <div class="option-desc">上传纸质营业执照原件图片</div>
            </div>
          </div>

          <!-- 电子营业执照（预留，可扩展） -->
          <div class="option">
            <div class="option-icon"><img src="./assets/img/links.png" alt=""></div>
            <div class="option-content">
              <div class="option-title">电子营业执照</div>
              <div class="option-desc">跳转微信小程序授权认证</div>
            </div>
          </div>

          <!-- 管理员验证 -->
<!--           <div class="option" @click="handleAdminVerify">
            <div class="option-icon"><img src="./assets/img/admin.png" alt=""></div>
            <div class="option-content">
              <div class="option-title">管理员验证</div>
              <div class="option-desc">选择你公司具有管理员权限的员工申请验证</div>
            </div>
          </div> -->
        </div>
        
        <!-- 步骤3的按钮 -->
        <div class="flex-row footer" style="position: relative; margin-top: 30px;">
          <button class="cancelButton" @click="handleBackStep">取消</button>
        </div>
      </div>

      <!-- 步骤4 - 营业执照上传 -->
      <div v-if="currentStep === 4" key="step4">
        <!-- 公司名称显示和修改链接 -->
        <div class="company-header">
          <span class="company-name">请上传{{ company?.company_name || formData.companyName }}的营业执照</span>
          <a href="#" class="modify-company" @click.prevent="handleModifyCompany">修改</a>
        </div>

        <!-- 上传区域和要求的左右布局 -->
        <div class="upload-container">
          <!-- 左侧：上传区域 -->
          <div class="upload-area" @click="handleFileUpload">
            <!-- 显示上传的图片 -->
            <div v-if="uploadedImageUrl" class="uploaded-image">
              <img :src="uploadedImageUrl" alt="已上传的营业执照" />
              <div class="image-overlay">
                <div class="upload-text">重新上传</div>
              </div>
            </div>
            <!-- 默认上传状态 -->
            <div v-else class="upload-placeholder">
              <div class="upload-icon" v-if="!isUploading">
                <img src="./assets/img/upload.svg" alt="上传图标" />
              </div>
              <div class="upload-loading" v-if="isUploading">
                <div class="loading-spinner"></div>
              </div>
              <div class="upload-text">{{ isUploading ? '上传中...' : '点击上传' }}</div>
            </div>
            <input 
              type="file" 
              ref="fileInput" 
              @change="handleFileChange" 
              accept="image/*" 
              style="display: none;"
            />
          </div>

          <!-- 右侧：上传要求 -->
          <div class="upload-requirements">
            <div class="requirement-item">1. 拍摄/上传与所填公司全称一致的营业执照</div>
            <div class="requirement-item">2. 最新下发的营业执照</div>
            <div class="requirement-item">3. 营业执照信息与公章清晰可见</div>
            <div class="requirement-item">4. 如上传复印件/彩印请加盖公司公章</div>
          </div>
        </div>

        <!-- 支持格式示例 -->
        <div class="format-examples">
          <div class="format-title">支持以下格式</div>
          <div class="format-images">
            <img src="./assets/img/company.png" alt="营业执照格式示例" class="format-combined" />
          </div>
        </div>

        <!-- 已上传文件显示 -->
        <div v-if="uploadedFile" class="uploaded-file">
          <div class="file-info">
            <img src="./assets/img/upload.svg" alt="文件图标" />
            <span class="file-name">{{ uploadedFile.name }}</span>
            <button class="remove-file" @click="removeFile">×</button>
          </div>
        </div>

        <!-- 步骤4的按钮 -->
        <div class="flex-row footer" style="position: relative; margin-top: 30px;">
          <button 
            class="submitButton" 
            :class="{ 'disabled': !uploadedFile || !uploadedImageUrl }"
            @click="handleStartVerify" 
            :disabled="!uploadedFile || !uploadedImageUrl"
          >
            开始验证
          </button>
          <button class="cancelButton" @click="handleChangeAuthMethod">更换认证方式</button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {
  getCompanyList,
  confirmCompanyAndInitFace,
  queryFaceVerificationResult,
  bindCompanyInfo
} from '@/api/verify'
import {getBusinessInfo} from '@/api/login'
import {lxUploadFile, yyzzUploadFile} from '@/api/upload'

export default {
  inject: ['updateText', 'updateTitle'],
  data() {
    const validateIdNo = (rule, value, callback) => {
      const reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
      if (!reg.test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    };
    return {
      currentStep: 1,       // 当前步骤
      formData: {
        companyName: '',     // 输入/回填的公司名称
        userPosition: '',    // 用户职位
        userName: '',        // 用户姓名
        userIdNo: '',       // 用户身份证号
        userPhone: ''        // 用户手机号
      },
      company: null,        // 最终选中的企业信息
      certifyId: '',        // 人脸核身流水号
      pollingTimer: null,   // 轮询定时器
      
      // 自动补全相关状态
      companySuggestions: [], // 公司建议列表
      showSuggestions: false, // 是否显示建议列表
      selectedIndex: -1,      // 当前选中的建议项索引
      searchTimer: null,      // 搜索防抖定时器
      
      // 第二个输入框的自动补全状态
      positionSuggestions: [],   // 职位建议列表
      showPositionSuggestions: false, // 是否显示职位建议列表
      selectedPositionIndex: -1,     // 当前选中的职位建议项索引
      positionSearchTimer: null,      // 职位搜索防抖定时器
      
      // 文件上传相关
      uploadedFile: null,             // 已上传的文件
      uploadedImageUrl: '',           // 上传后的图片URL
      isUploading: false             // 是否正在上传
    }
  },

  beforeDestroy() {
    this.clearPolling()
    this.clearSearchTimer()
    this.clearPositionSearchTimer()
  },
  async mounted() {
    // 通知父组件更新文本
    this.updateParentText();
    
    // 尝试从本地存储恢复公司验证信息
    const storedInfo = localStorage.getItem('companyVerifyInfo');
    if (storedInfo) {
      try {
        const companyInfo = JSON.parse(storedInfo);
        this.certifyId = companyInfo.certifyId;
        this.company = companyInfo.companyData;
        this.formData = { ...this.formData, ...companyInfo.formData };
        console.log('🔄 从本地存储恢复公司验证信息:', companyInfo);
      } catch (e) {
        console.log('❌ 解析本地存储数据失败:', e);
        localStorage.removeItem('companyVerifyInfo');
      }
    }
    
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get('response');
    if (!encoded) return;

    try {
      const decoded = decodeURIComponent(encoded);
      const res = JSON.parse(decoded);

      // 1. 公共日志（可选）
      console.info('[face-callback]', res);

      const { code, subCode, reason, certifyId, status } = res;
      
      // 检查认证结果，但仍需要调用API获取完整信息
      if (status === 'SUCCESS' && code === 1000) {
        console.log('✅ 从URL参数检测到认证成功，调用API获取完整信息');
        
        // 从本地存储获取公司验证信息
        const storedInfo = localStorage.getItem('companyVerifyInfo');
        console.log('🔍 从本地存储获取公司验证信息:', storedInfo);
        
        if (storedInfo) {
          try {
            const companyInfo = JSON.parse(storedInfo);
            this.certifyId = companyInfo.certifyId;
            this.company = companyInfo.companyData;
            this.formData = { ...this.formData, ...companyInfo.formData };
            console.log('✅ 恢复公司验证信息成功');
            this.checkFaceResultOnce(this.certifyId);
          } catch (e) {
            console.log('❌ 解析本地存储数据失败:', e);
            this.$message.error('数据解析失败，请重新开始验证流程');
          }
        } else {
          console.log('❌ 本地存储中未找到公司验证信息');
          this.$message.error('验证信息丢失，请重新开始验证流程');
        }
        return;
      }


      // 2. 核心逻辑：按 code + subCode 组合处理
      if (code === 1000 || (code === 2006 && subCode === 'H5057')) {
        // 场景：刷脸完成（1000）或刷脸失败（2006+H5057），需查询结果
        console.log('🎯 处理认证回调，code:', code, 'status:', res.status);
        
        if (code === 1000 && res.status === 'SUCCESS') {
          console.log('✅ 认证成功，直接绑定企业');
          await this.bindCompany();
        } else {
          console.log('🔍 需要查询认证结果，认证ID:', this.certifyId);
          this.checkFaceResultOnce(this.certifyId);
        }
      } else if (code === 1003) {
        // 场景：code=1003 下的各类 subCode 处理
        switch (subCode) {
          case 'H1001': // 频次过高/失败过多
          case 'H5056': // 重试次数超限
            this.$confirm(reason, '提示', {
              confirmButtonText: '重新刷脸',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.restartFace(); // 重新拉起刷脸
            });
            break;

          case 'H2007': // API 限流
          case 'H5052': // 网络异常
          case 'H5053': // 初始化失败
            this.$alert(`${reason}（流水号：${this.certifyId}）`, '系统异常', {
              confirmButtonText: '我知道了',
              type: 'error'
            });
            break;

          case 'H5000': // 用户切出页面
          case 'H5055': // 用户主动取消
            this.$message.warning(reason);
            break;

          case 'H5054': // 摄像头权限失败
            this.$confirm(reason, '需要摄像头权限', {
              confirmButtonText: '去设置',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.open('chrome://settings/content/camera', '_blank'); // 引导设置
            });
            break;

          default:
            // 兜底：code=1003 但 subCode 未覆盖（理论上不会出现）
            this.$message.error(reason || '未知错误');
            break;
        }
      } else {
        // 兜底：其他 code 或非法组合
        this.$message.error(reason || '未知错误');
      }

    } catch (e) {
      console.error(e);
      this.$message.error('解析回调参数失败');
    }
  },

  methods: {
    async checkFaceResultOnce(certifyId) {
      try {
        console.log('=== 检查人脸核身结果 ===');
        console.log('认证ID:', certifyId);
        
        const { data } = await queryFaceVerificationResult({ certifyId })
        console.log('📊 查询结果:', data);
        
        // 检查多种可能的状态字段
        const isSuccess = data.data.certify_state === 'SUCCESS' || 
                         data.data.status === 'SUCCESS' || 
                         data.status === 'SUCCESS' ||
                         data.code === 1000 ||
                         (data.data && data.data.certify_state === 'SUCCESS');
        
        console.log('🔍 状态检查:');
        console.log('- certify_state:', data.data?.certify_state);
        console.log('- data.status:', data.data?.status);
        console.log('- status:', data.status);
        console.log('- code:', data.code);
        console.log('- 判断结果:', isSuccess);
        
        if (isSuccess) {
          console.log('✅ 人脸核身成功，开始绑定企业');
          await this.bindCompany()
        } else {
          console.log('❌ 人脸核身失败，状态:', data.data?.certify_state || data.status);
          this.$message.error('人脸核身失败')
        }
      } catch (e) {
        console.log('❌ 查询失败:', e);
        this.$message.error(e?.msg || '结果查询失败')
      }
    },

    /* 步骤控制 */
    async handleNextStep() {
      console.log('=== 步骤控制调试信息 ===');
      console.log('当前步骤:', this.currentStep);
      console.log('表单数据:', this.formData);
      
      if (this.currentStep === 1) {
        console.log('步骤1: 验证公司信息');
        if (!this.formData.companyName.trim()) {
          console.log('❌ 公司名称为空');
          this.$message.warning('请输入公司全称')
          return
        }
        console.log('✅ 公司名称:', this.formData.companyName);
        
        try {
          console.log('🔍 开始查询企业信息...');
          const { data } = await getBusinessInfo({ name: this.formData.companyName })
          console.log('📊 查询结果:', data);

          if (data.code != 1) {
            console.log('❌ 未查到相关企业');
            this.$message.warning('未查到相关企业，请确认公司全称')
            return
          }
          // 检查返回的数据结构
          console.log('📊 原始返回数据:', data.data);
          if (Array.isArray(data.data) && data.data.length > 0) {
            this.company = data.data[0]; // 取第一个企业
            console.log('✅ 查询到的企业信息（数组第一个）:', this.company);
          } else if (typeof data.data === 'object') {
            this.company = data.data;
            console.log('✅ 查询到的企业信息（对象）:', this.company);
          } else {
            console.log('❌ 企业数据格式异常:', data.data);
            this.$message.warning('企业数据格式异常');
            return;
          }

          console.log('🔄 切换到步骤2');
          this.currentStep = 2
          this.updateParentText()
        } catch (e) {
          console.log('❌ 查询失败:', e);
          this.$message.error(e?.msg || '查询失败')
        }
      } else if (this.currentStep === 2) {
        console.log('步骤2: 验证个人信息');
        console.log('用户信息:', {
          userName: this.formData.userName,
          userIdNo: this.formData.userIdNo,
          userPhone: this.formData.userPhone
        });
        
        // 验证个人信息
        if (!this.formData.userName.trim()) {
          console.log('❌ 用户姓名为空');
          this.$message.warning('请输入您的姓名');
          return;
        }
        if (!this.formData.userIdNo.trim()) {
          console.log('❌ 身份证号为空');
          this.$message.warning('请输入您的身份证号');
          return;
        }
        if (!this.formData.userPhone.trim()) {
          console.log('❌ 手机号为空');
          this.$message.warning('请输入您的手机号');
          return;
        }
        
        console.log('✅ 个人信息验证通过，直接跳转到管理员验证');
        // 直接跳转到管理员验证
        this.handleAdminVerify();
        return;
      } else if (this.currentStep === 3) {
        console.log('步骤3: 验证方式选择');
        console.log('⚠️ 步骤3没有默认的下一步操作，请选择具体的验证方式');
        this.$message.warning('请选择具体的验证方式');
        return;
      }
    },
    handleBackStep() {
      console.log('=== 后退步骤调试信息 ===');
      console.log('当前步骤:', this.currentStep);
      console.log('执行清理操作...');
      
      this.clearPolling()
      if (this.currentStep > 1) {
        console.log('🔄 后退到步骤:', this.currentStep - 1);
        this.currentStep -= 1
        this.updateParentText()
        console.log('✅ 步骤切换完成');
      } else {
        console.log('❌ 已在第一步，无法后退');
      }
    },

    /* 管理员验证 */
    async handleAdminVerify() {
      console.log('=== 管理员验证调试信息 ===');
      console.log('当前步骤:', this.currentStep);
      console.log('企业信息:', this.company);
      console.log('企业信息类型:', typeof this.company);
      console.log('企业信息键值:', this.company ? Object.keys(this.company) : 'null');
      
      if (!this.company) {
        console.log('❌ 企业信息缺失');
        return this.$message.error('企业信息缺失')
      }
      
      // 检查企业名称字段
      console.log('企业名称字段检查:');
      console.log('- company_name:', this.company.company_name);
      console.log('- name:', this.company.name);
      console.log('- companyName:', this.company.companyName);
      console.log('- 表单中的公司名称:', this.formData.companyName);
      
      try {
        console.log('🔍 获取用户实名信息...');
        const userInfo = await this.getUserRealInfo()
        console.log('👤 用户信息:', userInfo);

        console.log('🚀 开始管理员验证...');
        console.log('📋 传递的参数:', {
          company_name: this.company.company_name,
          cert_name: userInfo.name,
          cert_no: userInfo.id_card
        });
        
        // 检查企业名称是否存在
        if (!this.company.company_name) {
          console.log('❌ 企业名称为空，使用公司全称作为备选');
          const companyName = this.formData.companyName || '未知公司';
          console.log('🔄 使用备选企业名称:', companyName);
        }
        
        const { data } = await confirmCompanyAndInitFace({
          company_name: this.company.company_name || this.formData.companyName,
          cert_name: userInfo.name,
          cert_no: userInfo.id_card
        })
        console.log('✅ 管理员验证结果:', data);

        // 检查返回结果
        if (data.code === 0) {
          console.log('❌ 管理员验证失败:', data.msg);
          this.$message.error(data.msg || '管理员验证失败');
          return;
        }

        if (!data.data || !data.data.certify_id) {
          console.log('❌ 认证ID缺失');
          this.$message.error('认证ID缺失，请重试');
          return;
        }

        this.certifyId = data.data.certify_id
        console.log('🆔 认证ID:', this.certifyId);
        
        // 持久化存储认证ID和公司信息
        const companyInfo = {
          certifyId: this.certifyId,
          companyName: this.company?.company_name || this.formData.companyName,
          companyData: this.company,
          formData: this.formData
        };
        localStorage.setItem('companyVerifyInfo', JSON.stringify(companyInfo));
        console.log('💾 公司验证信息已保存到本地存储:', companyInfo);
        
        const callback = encodeURIComponent(window.location.origin + window.location.pathname + window.location.hash);
        console.log('🔗 回调URL:', callback);
        console.log('🌐 跳转到验证页面:', data.data.web_url);

        window.open(`${data.data.web_url}?callbackUrl=${callback}`, '_blank');

      } catch (e) {
        console.log('❌ 管理员验证失败:', e);
        this.$message.error(e?.msg || '初始化失败')
      }
    },

    /* 轮询核身结果 */
    startPolling() {
      console.log('=== 开始轮询核身结果 ===');
      console.log('认证ID:', this.certifyId);
      
      this.clearPolling()
      this.pollingTimer = setInterval(async () => {
        try {
          console.log('🔍 轮询查询核身结果...');
          const { data } = await queryFaceVerificationResult({ certifyId: this.certifyId })
          console.log('📊 轮询查询结果:', data);

          // 检查多种可能的状态字段
          const isSuccess = data.data.certify_state === 'SUCCESS' || 
                           data.data.status === 'SUCCESS' || 
                           data.status === 'SUCCESS' ||
                           data.code === 1000;
          
          const isFail = data.data.certify_state === 'FAIL' || 
                        data.data.status === 'FAIL' || 
                        data.status === 'FAIL' ||
                        data.code === 2006;
          
          console.log('🔍 轮询状态检查:');
          console.log('- certify_state:', data.data.certify_state);
          console.log('- data.status:', data.data.status);
          console.log('- status:', data.status);
          console.log('- code:', data.code);
          console.log('- 成功判断:', isSuccess);
          console.log('- 失败判断:', isFail);

          if (isSuccess) {
            console.log('✅ 人脸核身成功');
            this.clearPolling()
            await this.bindCompany()
          } else if (isFail) {
            console.log('❌ 人脸核身失败');
            this.clearPolling()
            this.$message.error('人脸核身失败')
          } else {
            console.log('⏳ 核身状态:', data.data.certify_state || data.status, '继续等待...');
          }
        } catch (e) {
          console.log('❌ 轮询查询失败:', e);
          this.clearPolling()
          this.$message.error(e?.msg || '查询失败')
        }
      }, 2000)
    },
    clearPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },

    /* 绑定企业 */
    async bindCompany() {
      console.log('=== 绑定企业调试信息 ===');
      console.log('企业信息:', this.company);
      console.log('表单数据:', this.formData);

      try {
        // 使用用户输入的公司名称
        const companyName = this.company?.company_name || this.formData.companyName;
        console.log('🔗 开始绑定企业信息，公司名称:', companyName);
        
        if (!companyName) {
          console.log('❌ 公司名称为空');
          this.$message.error('公司名称不能为空');
          return;
        }
        
        const info = await bindCompanyInfo({ company_name: companyName })
        console.log('📊 绑定结果:', info);
        
        if (info.data.data.is_verified == 1) {
          console.log('✅ 个人认证成功');
          this.$message.success('个人认证成功')
          
          // 清除本地存储的公司验证信息
          localStorage.removeItem('companyVerifyInfo');
          console.log('🧹 已清除本地存储的公司验证信息');
          
          console.log('🔄 跳转到步骤3 - 验证方式选择');
          this.currentStep = 3;
          this.updateParentText();
        } else {
          console.log('❌ 企业认证失败，验证状态:', info.data.data.is_verified);
        }

      } catch (e) {
        console.log('❌ 绑定企业失败:', e);
        this.$message.error(e?.msg || '绑定失败')
      }
    },

    /* 获取当前用户实名信息 */
    async getUserRealInfo() {
      console.log('=== 获取用户实名信息 ===');
      const userInfo = {
        name: this.formData.userName || '张三',
        id_card: this.formData.userIdNo || '123456789012345678'
      };
      console.log('👤 用户实名信息:', userInfo);
      return userInfo;
    },

    /* 自动补全相关方法 */
    // 处理公司名称输入
    handleCompanyInput() {
      const query = this.formData.companyName.trim()
      
      // 清除之前的定时器
      this.clearSearchTimer()
      
      if (query.length < 2) {
        this.hideSuggestions()
        return
      }
      
      // 设置防抖，500ms后执行搜索
      this.searchTimer = setTimeout(() => {
        this.searchCompanies(query)
      }, 500)
    },

    // 搜索公司
    async searchCompanies(query) {
      try {
        const { data } = await getBusinessInfo({ name: query })
        
        if (data.code === 1 && Array.isArray(data.data)) {
          this.companySuggestions = data.data
          this.showSuggestions = true
          this.selectedIndex = -1
        } else {
          this.hideSuggestions()
        }
      } catch (error) {
        console.error('搜索公司失败:', error)
        this.hideSuggestions()
      }
    },

    // 隐藏建议列表
    hideSuggestions() {
      this.showSuggestions = false
      this.companySuggestions = []
      this.selectedIndex = -1
    },

    // 清除搜索定时器
    clearSearchTimer() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }
    },

    // 处理输入框获得焦点
    handleInputFocus() {
      if (this.companySuggestions.length > 0) {
        this.showSuggestions = true
      }
    },

    // 处理输入框失去焦点
    handleInputBlur() {
      // 延迟隐藏，让点击事件先执行
      setTimeout(() => {
        this.hideSuggestions()
      }, 200)
    },

    // 处理键盘事件
    handleKeydown(event) {
      if (!this.showSuggestions || this.companySuggestions.length === 0) {
        return
      }

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault()
          this.selectedIndex = Math.min(this.selectedIndex + 1, this.companySuggestions.length - 1)
          break
        case 'ArrowUp':
          event.preventDefault()
          this.selectedIndex = Math.max(this.selectedIndex - 1, -1)
          break
        case 'Enter':
          event.preventDefault()
          if (this.selectedIndex >= 0) {
            this.selectCompany(this.companySuggestions[this.selectedIndex])
          }
          break
        case 'Escape':
          this.hideSuggestions()
          break
      }
    },

    // 选择公司
    selectCompany(company) {
      this.formData.companyName = company.company_name
      this.company = company
      this.hideSuggestions()
    },

    // 高亮匹配文本
    highlightMatch(text, query) {
      if (!query || !text) return text
      
      // 转义特殊字符，避免正则表达式错误
      const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const regex = new RegExp(`(${escapedQuery})`, 'gi')
      return text.replace(regex, '<span class="highlight">$1</span>')
    },

    /* 第二个输入框的自动补全方法 */
    // 处理职位输入
    handlePositionInput() {
      const query = this.formData.userPosition.trim()
      
      // 清除之前的定时器
      this.clearPositionSearchTimer()
      
      if (query.length < 2) {
        this.hidePositionSuggestions()
        return
      }
      
      // 设置防抖，500ms后执行搜索
      this.positionSearchTimer = setTimeout(() => {
        this.searchPositions(query)
      }, 500)
    },

    // 搜索职位
    async searchPositions(query) {
      try {
        // 这里可以调用职位搜索API，暂时使用模拟数据
        const mockPositions = [
          { name: '产品经理', id: 1 },
          { name: '前端开发工程师', id: 2 },
          { name: '后端开发工程师', id: 3 },
          { name: 'UI设计师', id: 4 },
          { name: '运营专员', id: 5 },
          { name: '市场经理', id: 6 },
          { name: '销售经理', id: 7 },
          { name: '人事专员', id: 8 },
          { name: '财务经理', id: 9 },
          { name: '技术总监', id: 10 }
        ].filter(pos => pos.name.includes(query))
        
        this.positionSuggestions = mockPositions
        this.showPositionSuggestions = true
        this.selectedPositionIndex = -1
      } catch (error) {
        console.error('搜索职位失败:', error)
        this.hidePositionSuggestions()
      }
    },

    // 隐藏职位建议列表
    hidePositionSuggestions() {
      this.showPositionSuggestions = false
      this.positionSuggestions = []
      this.selectedPositionIndex = -1
    },

    // 清除职位搜索定时器
    clearPositionSearchTimer() {
      if (this.positionSearchTimer) {
        clearTimeout(this.positionSearchTimer)
        this.positionSearchTimer = null
      }
    },

    // 处理职位输入框获得焦点
    handlePositionFocus() {
      if (this.positionSuggestions.length > 0) {
        this.showPositionSuggestions = true
      }
    },

    // 处理职位输入框失去焦点
    handlePositionBlur() {
      // 延迟隐藏，让点击事件先执行
      setTimeout(() => {
        this.hidePositionSuggestions()
      }, 200)
    },

    // 处理职位键盘事件
    handlePositionKeydown(event) {
      if (!this.showPositionSuggestions || this.positionSuggestions.length === 0) {
        return
      }

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault()
          this.selectedPositionIndex = Math.min(this.selectedPositionIndex + 1, this.positionSuggestions.length - 1)
          break
        case 'ArrowUp':
          event.preventDefault()
          this.selectedPositionIndex = Math.max(this.selectedPositionIndex - 1, -1)
          break
        case 'Enter':
          event.preventDefault()
          if (this.selectedPositionIndex >= 0) {
            this.selectPosition(this.positionSuggestions[this.selectedPositionIndex])
          }
          break
        case 'Escape':
          this.hidePositionSuggestions()
          break
      }
    },

    // 选择职位
    selectPosition(position) {
      this.formData.userPosition = position.name
      this.hidePositionSuggestions()
    },

    // 文件上传相关方法
    handleFileUpload() {
      console.log('📁 点击文件上传');
      this.$refs.fileInput.click();
    },

    async handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        console.log('📄 选择文件:', file.name, '大小:', file.size);
        
        // 验证文件类型
        if (!file.type.startsWith('image/')) {
          this.$message.error('请选择图片文件');
          return;
        }
        
        // 验证文件大小 (5MB)
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('文件大小不能超过5MB');
          return;
        }
        
        this.uploadedFile = file;
        console.log('✅ 文件选择成功');
        
        // 自动上传文件
        await this.uploadFile(file);
      }
    },

    removeFile() {
      console.log('🗑️ 移除文件');
      this.uploadedFile = null;
      this.uploadedImageUrl = '';
      this.$refs.fileInput.value = '';
    },

    async uploadFile(file) {
      try {
        this.isUploading = true;
        console.log('🚀 开始上传文件:', file.name);
        
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await lxUploadFile(formData);
        console.log('📤 上传响应:', response);
        
        if (response.data && response.data.data && response.data.data.url) {
          this.uploadedImageUrl = response.data.data.url;
          console.log('✅ 文件上传成功，URL:', this.uploadedImageUrl);
          this.$message.success('文件上传成功');
          
          // 文件上传成功，但不自动验证，等待用户点击"开始验证"按钮
        } else {
          console.log('❌ 上传响应结构异常:', response);
          throw new Error('上传响应中未找到URL');
        }
      } catch (error) {
        console.log('❌ 文件上传失败:', error);
        this.$message.error('文件上传失败，请重试');
        this.uploadedFile = null;
        this.uploadedImageUrl = '';
      } finally {
        this.isUploading = false;
      }
    },

    async verifyBusinessLicense() {
      try {
        console.log('🔍 开始营业执照验证');
        const params = {
          detect_direction: false,
          image_url: this.uploadedImageUrl,
          probability: false
        };
        console.log('📋 验证参数:', params);
        
        const response = await yyzzUploadFile(params);
        console.log('📊 营业执照验证结果:', response);
        
        if (response.data) {
          console.log('✅ 营业执照验证成功');
          this.$message.success('营业执照验证成功');
          // 可以在这里处理验证结果，比如提取公司信息等
        } else {
          console.log('❌ 营业执照验证失败');
          this.$message.error('营业执照验证失败');
        }
      } catch (error) {
        console.log('❌ 营业执照验证失败:', error);
        this.$message.error('营业执照验证失败');
      }
    },

    async handleStartVerify() {
      console.log('🔍 开始验证营业执照');
      if (!this.uploadedImageUrl) {
        this.$message.warning('请先上传营业执照');
        return;
      }
      
      // 执行营业执照验证
      await this.verifyBusinessLicense();
    },

    handleChangeAuthMethod() {
      console.log('🔄 更换认证方式');
      this.currentStep = 3;
      this.updateParentText();
    },

    handleModifyCompany() {
      console.log('🔄 修改公司信息');
      this.currentStep = 1;
      this.updateParentText();
    },

    handleLicenseUpload() {
      console.log('📄 选择营业执照上传');
      console.log('🔄 当前步骤:', this.currentStep);
      this.currentStep = 4;
      console.log('✅ 步骤已切换到:', this.currentStep);
      this.updateParentText();
      console.log('✅ 父组件文本已更新');
    },

    // 更新父组件文本
    updateParentText() {
      console.log('=== 更新父组件文本 ===');
      console.log('当前步骤:', this.currentStep);
      
      const stepConfig = {
        1: {
          title: '企业认证',
          text: '请验证您所属的公司'
        },
        2: {
          title: '个人信息',
          text: '请填写您的个人信息'
        },
        3: {
          title: '验证方式',
          text: '请选择验证方式'
        },
        4: {
          title: '营业执照',
          text: '请验证您所属的公司'
        }
      };
      
      const config = stepConfig[this.currentStep] || stepConfig[1];
      console.log('📝 更新配置:', config);
      
      // 直接调用父组件的方法
      if (this.updateTitle) {
        console.log('🔄 更新标题:', config.title);
        this.updateTitle(config.title);
      }
      if (this.updateText) {
        console.log('🔄 更新文本:', config.text);
        this.updateText(config.text);
      }
      console.log('✅ 父组件文本更新完成');
    }
  }
}
</script>
<style scoped lang="scss">
.form-container {
  width: 100%;
  height: 80%;
  padding: 20px;
  background-color: transparent;
  overflow: hidden;
  position: relative;
}

.container {
  width: 100%;
  margin-bottom: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}

.title {
  color: #656587;
  text-align: center;
  font-family: Afacad;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}


.input-container {
  position: relative;
  margin: 20px 0;
}

.autocomplete-wrapper {
  position: relative;
  width: 100%;
}

.input-field {
  width: 100%;
  height: 60px;
  border-radius: 24px;
  border: 1px solid var(--Linear, #B16EF9);
  background-color: transparent;
  /* 设置背景透明 */
  opacity: 0.8;
  font-size: 18px;
  padding: 0 20px;
  outline: none;
  transition: border-color 0.3s;
}

.input-field:focus {
  border-color: #1890ff;
}

.placeholder {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #bfbfbf;
  font-size: 18px;
  pointer-events: none;
}

.input-field:not(:placeholder-shown)+.placeholder {
  opacity: 0;
  transition: opacity 0.3s;
}

.flex-row {
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
}

.submitButton {
  width: 180px;
  height: 50px;
  border-radius: 18px;
  background: linear-gradient(90deg, rgba(126, 180, 235, 1) 0%, rgba(177, 110, 249, 1) 100%);
  color: white;
  font-size: 18px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: transparent;
}

.cancelButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(177, 110, 249, 0.3);
}
.cancelButton {
  width: 180px;
  height: 50px;
  border-radius: 18px;
  background: white;
  color: #656587;
  font-size: 18px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;

}

.submitButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(177, 110, 249, 0.3);
}


.upload-options {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 500px;
  margin: 50px auto;
}

.option {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.option:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 12px;
  font-size: 20px;
  color: #666;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.option-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.option-desc {
  font-size: 14px;
  color: #999;
}

.option-content {
  flex: 1;
}

/* 滑动动画样式 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.hide-upload {
  display: none;
}

.footer {
  position: relative;
  width: 100%;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}

/* 自动补全下拉列表样式 */
.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(224, 224, 224, 0.3) !important;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 4px;
}

/* 使用深度选择器确保透明度效果生效 */
:deep(.suggestions-dropdown) {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(224, 224, 224, 0.3) !important;
}

.suggestion-item {
  padding: 12px 20px;
  cursor: pointer;
  border-bottom: 1px solid rgba(240, 240, 240, 0.5) !important;
  transition: background-color 0.2s;
  font-size: 14px;
  color: #333;
  background: rgba(255, 255, 255, 0.8) !important;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover,
.suggestion-item.active {
  background-color: rgba(248, 249, 255, 0.9) !important;
}

/* 使用深度选择器确保建议项透明度效果生效 */
:deep(.suggestion-item) {
  background: rgba(255, 255, 255, 0.8) !important;
  border-bottom: 1px solid rgba(240, 240, 240, 0.5) !important;
}

:deep(.suggestion-item:hover),
:deep(.suggestion-item.active) {
  background-color: rgba(248, 249, 255, 0.9) !important;
}

.suggestion-item .highlight {
  color: #B16EF9;
  font-weight: 600;
}

/* 使用深度选择器确保动态HTML内容也能应用样式 */
.suggestion-item ::v-deep .highlight {
  color: #B16EF9 !important;
  font-weight: 600 !important;
}

/* 全局高亮样式，确保动态内容也能正确显示 */
:deep(.highlight) {
  color: #B16EF9 !important;
  font-weight: 600 !important;
}

/* 步骤4 - 营业执照上传样式 */
.company-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 0 20px;
}

.company-name {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.modify-company {
  color: #B16EF9;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
}

.modify-company:hover {
  text-decoration: underline;
}

.upload-container {
  display: flex;
  gap: 40px;
  margin-bottom: 30px;
  align-items: flex-start;
}

.upload-area {
  width: 200px;
  height: 150px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafafa;
  flex-shrink: 0;
}

.upload-area:hover {
  border-color: #B16EF9;
  background: #f8f9ff;
}

.uploaded-image {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.uploaded-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-area:hover .image-overlay {
  opacity: 1;
}

.upload-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-loading {
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #B16EF9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 步骤4按钮禁用状态 */
.submitButton.disabled {
  background: #ccc !important;
  color: #999 !important;
  cursor: not-allowed !important;
  border: 1px solid #ddd !important;
}

.submitButton.disabled:hover {
  background: #ccc !important;
  color: #999 !important;
  transform: none !important;
  box-shadow: none !important;
}

.upload-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
}

.upload-icon img {
  width: 100%;
  height: 100%;
  opacity: 0.6;
}

.upload-text {
  color: #666;
  font-size: 14px;
}

.upload-requirements {
  flex: 1;
  padding: 0;
}

.requirement-item {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 8px;
}

.format-examples {
  margin-bottom: 30px;
  padding: 0 20px;
}

.format-title {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
}

.format-images {
  display: flex;
  justify-content: center;
}

.format-combined {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.uploaded-file {
  margin: 20px 0;
  padding: 0 20px;
}

.file-info {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f8f9ff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.file-info img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.file-name {
  flex: 1;
  color: #333;
  font-size: 14px;
}

.remove-file {
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-file:hover {
  color: #ff4757;
}
</style>